import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as i18next from 'i18next';
import * as api from 'core/api';
import * as flights from 'core/flights';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class OrderViewSidebarComponent extends Vue {
    @Prop()
    reservation: api.ReservationInfo;

    @Prop()
    flight: flights.FlightModel;

    get orderTotal(): number {
        return this.reservation.amount - this.reservation.couponDiscountAmount;
    }

    getBookingClassLabel(bookingClass: string): string {
        return i18next.t('label_flight_class_' + bookingClass.toLowerCase());
    }

    isTextStrikeNeeded(product: api.Product) {
        return product.status == api.ProductStatus.canceled
            || product.status == api.ProductStatus.deleted
            || product.status == api.ProductStatus.refunded;
    }

    crutchName(product: api.Product) { // Костыль на время тестов
        let newName = '';
        switch (product.kitId) {
            case 236:
                newName = 'Умный пакет';
                break;
            case 237:
                newName = 'Гарантия возврата билета в случае болезни';
                break;
            case 238:
                newName = 'Гарантированный возврат';
                break;
            default:
                newName = product.name;
                break;
        }

        return newName;
    }
}
